export const Options = {
    Salutation: [
        { text: "Herr", value: "m" },
        { text: "Frau", value: "w" },
        { text: "Divers", value: "d" },
    ],
    BecomingAwareThroughFormal: [
        { text: "Ausbildungsplattformen",value:"Ausbildungsplattformen"},
        { text: "Baustellenwerbung",value:"Baustellenwerbung"},
        { text: "Empfehlung durch Mitarbeitende (Mitarbeiter-werben-Mitarbeiter-Programm)",value:"Empfehlung durch Mitarbeitende (Mitarbeiter-werben-Mitarbeiter-Programm)"},
        { text: "Fahrzeugbeschriftung/Firmenfahrzeuge",value:"Fahrzeugbeschriftung/Firmenfahrzeuge"},
        { text: "Flyer/Plakate/Printanzeigen",value:"Flyer/Plakate/Printanzeigen"},
        { text: "Google",value:"Google"},
        { text: "Instagram/Facebook",value:"Instagram/Facebook"},
        { text: "Jobbörse der Arbeitsagentur",value:"Jobbörse der Arbeitsagentur"},
        { text: "Jobmessen/Karrieretage",value:"Jobmessen/Karrieretage"},
        { text: "Kununu",value:"Kununu"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "Online-Stellenbörse",value:"Online-Stellenbörse"},
        { text: "Schulen/Hochschulkooperationen",value:"Schulen/Hochschulkooperationen"},
        { text: "Vor-Ort-Kontakt (z. B. Laden, Standort, Infoveranstaltung)",value:"Vor-Ort-Kontakt (z. B. Laden, Standort, Infoveranstaltung)"},
        { text: "Webseite",value:"Webseite"},
        { text: "Xing",value:"Xing"},
        { text: "YouTube",value:"YouTube"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
    BecomingAwareThroughInformal: [
        { text: "Ausbildungsplattformen",value:"Ausbildungsplattformen"},
        { text: "Baustellenwerbung",value:"Baustellenwerbung"},
        { text: "Empfehlung durch Mitarbeitende (Mitarbeiter-werben-Mitarbeiter-Programm)",value:"Empfehlung durch Mitarbeitende (Mitarbeiter-werben-Mitarbeiter-Programm)"},
        { text: "Fahrzeugbeschriftung/Firmenfahrzeuge",value:"Fahrzeugbeschriftung/Firmenfahrzeuge"},
        { text: "Flyer/Plakate/Printanzeigen",value:"Flyer/Plakate/Printanzeigen"},
        { text: "Google",value:"Google"},
        { text: "Instagram/Facebook",value:"Instagram/Facebook"},
        { text: "Jobbörse der Arbeitsagentur",value:"Jobbörse der Arbeitsagentur"},
        { text: "Jobmessen/Karrieretage",value:"Jobmessen/Karrieretage"},
        { text: "Kununu",value:"Kununu"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "Online-Stellenbörse",value:"Online-Stellenbörse"},
        { text: "Schulen/Hochschulkooperationen",value:"Schulen/Hochschulkooperationen"},
        { text: "Vor-Ort-Kontakt (z. B. Laden, Standort, Infoveranstaltung)",value:"Vor-Ort-Kontakt (z. B. Laden, Standort, Infoveranstaltung)"},
        { text: "Webseite",value:"Webseite"},
        { text: "Xing",value:"Xing"},
        { text: "YouTube",value:"YouTube"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
    AdditionalConsent: [
        {text:"Ich willige ein, dass meine Daten für zukünftig zu besetzende Stellen von der MBN-Familie verarbeitet und gespeichert werden dürfen (Bewerberpool). Ein Widerruf ist jederzeit unter der E-Mail Adresse jobs@mbn.de möglich.",value:"Ich willige ein, dass meine Daten für zukünftig zu besetzende Stellen von der MBN-Familie verarbeitet und gespeichert werden dürfen (Bewerberpool). Ein Widerruf ist jederzeit unter der E-Mail Adresse jobs@mbn.de möglich."}
    ]
}
